"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AverageBuffer = void 0;
var buffer_list_1 = require("./buffer-list");
var AverageBuffer = /** @class */ (function () {
    function AverageBuffer(bufferSize) {
        this.bufferList = new buffer_list_1.BufferList(bufferSize);
    }
    AverageBuffer.prototype.addValue = function (value) {
        this.bufferList.push(value);
    };
    AverageBuffer.prototype.getAverage = function () {
        var values = this.bufferList.getItems();
        if (values.length === 0) {
            return 0;
        }
        var sum = values.reduce(function (a, b) { return a + b; }, 0);
        return sum / values.length;
    };
    return AverageBuffer;
}());
exports.AverageBuffer = AverageBuffer;
